import { render, staticRenderFns } from "./InsurancesPlanDetailsForm.vue?vue&type=template&id=4f5cdfe6&"
import script from "./InsurancesPlanDetailsForm.vue?vue&type=script&lang=js&"
export * from "./InsurancesPlanDetailsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports